import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { StyleSheet, css } from 'aphrodite';
import Isvg from 'react-inlinesvg';
import { Tooltip } from 'react-tippy';
import 'react-tippy/dist/tippy.css';
import ErrorContainer from '../ErrorContainer';

import { Theme } from '../../config/theme';

const TOOLTIP_ASSET = require('./tooltip.svg');
const CHECK_ASSET = require('./check.svg');

export default class CheckboxField extends Component {
  constructor(props) {
    super(props);
    this.assignClasses = this.assignClasses.bind(this);
    this.changeHandler = this.handleChange.bind(this);
    this.state = {
      error: null,
    };
  }

  assignClasses() {
    this.fieldClasses = [
      styles.field,
      this.props.fullWidth ? styles.field_fw : null,
    ];

    this.labelClasses = [
      styles.label,
      this.state.error ? styles.label_error : null,
    ];

    this.inputClasses = [
      styles.input,
      this.state.error ? styles.input_error : null,
    ];
  }

  handleChange() {
    this.props.handler(this.props.name, !this.props.value);
  }

  render() {
    this.assignClasses();

    return (
      <div className={css(this.fieldClasses)}>
        <input
          id={this.props.id}
          type="checkbox"
          onClick={this.changeHandler}
          name={this.props.name}
          className={css(this.inputClasses)}
          checked={this.props.value}
        />
        <label htmlFor={this.props.id} className={css(this.labelClasses)}>
          <span className={css(styles.label_text)}>{this.props.label}</span>

          {this.props.note ?
            <span className={css(styles.note)}>{this.props.note}</span>
          : null}

          {this.props.error ?
            <ErrorContainer message={this.props.error} />
          : null}
        </label>

        {this.props.tooltip ?
          <Tooltip
            position="bottom"
            arrow
            html={(
              <div className={css(styles.tooltip)}>
                {this.props.tooltip}
              </div>
            )}
            >
            <Isvg
              cacheGetRequests
              src={TOOLTIP_ASSET}
              className={css(styles.tooltip_trigger)}
            />
          </Tooltip>
        : null}
      </div>
    );
  }
}

CheckboxField.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  fullWidth: PropTypes.bool,
  tooltip: PropTypes.string,
  error: PropTypes.string,
  note: PropTypes.string,
  value: PropTypes.bool,
  handler: PropTypes.func.isRequired,
};

CheckboxField.defaultProps = {
  fullWidth: false,
  tooltip: null,
  error: null,
  note: null,
  value: false,
};

const styles = StyleSheet.create({
  note: {
    display: 'block',
    width: '100%',
    paddingLeft: 44,
    fontSize: 14,
    fontFamily: Theme.font_family_primary,
    color: '#828282',
  },
  tooltip: {
    padding: 5,
    fontSize: 14,
    fontFamily: Theme.font_family_primary,
  },
  tooltip_trigger: {
    display: 'flex',
    alignItems: 'center',
    margin: '0 10px',
    cursor: 'pointer',
  },
  field: {
    display: 'flex',
    alignItems: 'center',
    'user-select': 'none',
    position: 'relative',
    width: '50%',
    padding: '0 5px',
    [Theme.mobile_query]: {
      width: '100%',
      'margin-bottom': 15,
    },
  },
  field_fw: {
    width: '100%',
    ':not(:first-child)': {
      marginTop: 20,
    },
  },
  label: {
    userSelect: 'none',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    flexShrink: 0,
    fontFamily: Theme.font_family_primary,
    fontWeight: Theme.font_weight_primary,
    fontSize: 15,
    color: '#000e1f',
    cursor: 'pointer',
    [Theme.mobile_query]: {
      position: 'relative',
      paddingLeft: 44,
      minHeight: 30,
      paddingTop: '0.2em',
      flexShrink: 1,
    },
    ':before': {
      flexShrink: 0,
      display: 'block',
      width: 30,
      height: 30,
      margin: '0 14px 0 0',
      borderRadius: 3,
      backgroundColor: '#fff',
      border: '1px solid #e4e4e4',
      boxSizing: 'border-box',
      backgroundImage: `url(${CHECK_ASSET})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundSize: '0 0',
      content: '""',
      [Theme.mobile_query]: {
        position: 'absolute',
        top: 0,
        left: 0,
      },
    },
  },
  label_text: {
    minWidth: 50,
    flexGrow: 0,
    lineHeight: '1.5',
  },
  label_error: {
    color: '#E85E5E',
  },
  input: {
    position: 'absolute',
    top: 0,
    left: 5,
    width: 30,
    height: 30,
    opacity: 0,
    cursor: 'pointer',

    ':checked + label:before': {
      backgroundSize: '14px 13px',
    },
  },
  input_error: {
    color: '#E85E5E',
    borderColor: '#E85E5E',

    '::placeholder': {
      color: '#E85E5E',
    },
  },
});



// WEBPACK FOOTER //
// ./src/components/CheckboxField/index.js